var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconNextQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 46,
    viewBox: "0 0 51 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0801 5.06309C15.2253 4.93165 15.3977 4.82737 15.5875 4.75622C15.7774 4.68506 15.9809 4.64844 16.1864 4.64844C16.3919 4.64844 16.5954 4.68506 16.7852 4.75622C16.9751 4.82737 17.1475 4.93165 17.2926 5.06309L36.0426 21.9998C36.1881 22.1309 36.3036 22.2867 36.3824 22.4581C36.4611 22.6296 36.5017 22.8134 36.5017 22.9991C36.5017 23.1847 36.4611 23.3685 36.3824 23.54C36.3036 23.7115 36.1881 23.8672 36.0426 23.9983L17.2926 40.935C16.9992 41.2001 16.6013 41.3489 16.1864 41.3489C15.7715 41.3489 15.3735 41.2001 15.0801 40.935C14.7867 40.67 14.6219 40.3106 14.6219 39.9358C14.6219 39.561 14.7867 39.2015 15.0801 38.9365L32.727 22.9991L15.0801 7.06162C14.9346 6.93051 14.8192 6.77476 14.7404 6.60329C14.6616 6.43182 14.6211 6.248 14.6211 6.06235C14.6211 5.87671 14.6616 5.69288 14.7404 5.52141C14.8192 5.34994 14.9346 5.19419 15.0801 5.06309V5.06309Z",
    fill: "#B3B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconNextQuestion);
export default __webpack_public_path__ + "static/media/TH-Icon-Next-Question.e1c0f36a1ed829cc49082ab5664031f0.svg";
export { ForwardRef as ReactComponent };